<template>
	<b-container class="pt-4">
		<b-row>
			<b-col md="6">
				<h1>Tilmelding</h1>
				<p>Du kan oprette din SkvizBiz konto allerede i dag. Udfyld og indsend formularen til højre, så sender vi dig dit personlige login til SkvizBiz. Du vælger selv om du vil bestille programmet med det samme, eller om du ønsker at prøve det gratis i 30 dage først.</p>
				<p>Hvis du prøver SkvizBiz i 30 dage, tror vi ikke at du bagefter har lyst til at undvære det igen, så til den tid kan du selvfølgelig opgradere din demokonto til en fuld licens uden at miste data. Det vil sige at du uhindret kan arbejde videre med de informationer, du allerede har indtastet i SkvizBiz.</p>
				<p>Hvis der opstår spørgsmål mens du afprøver SkvizBiz, eller hvis du ønsker yderligere information, er du velkommen til at kontakte os. Vi anbefaler også at du ser vores <b-link to="/videoer">videokurser</b-link>.<br>
				Vi glæder os til at samarbejde med dig!</p>
				
				<!-- <hr> -->
			</b-col>
			<b-col md="6">

				<h1>Hvad sker der når jeg har tilmeldt mig?</h1>
				<p>Når vi har modtaget og behandlet din tilmelding, sender vi dig en email med de oplysninger, du skal bruge for at kunne logge dig ind på SkvizBiz, og så er du klar til at gå i gang.</p>
				<p>Uanset om du har bestilt en demo-konto eller en fuld licens, kan du så med det samme begynde at indtaste kundeoplysninger i programmet. Hvis du har en fil med kundedata, som skal indlæses på din SkvizBiz konto, skal du maile kundefilen til os på <b-link href="mailto:support@skvizbiz.dk">support@skvizbiz.dk</b-link>, så indlæser vi den ved bestilling.</p>
				<p>Hvis du bestiller fuld licens til programmet, sender vi dig en faktura på email, når vi har behandlet din tilmelding. </p>
			</b-col>
		</b-row>
		<sb-signup />
	</b-container>
</template>

<script>
import sbSignup from '../components/Signup.vue';
import {
	BContainer,
	BRow,
	BCol,
	BLink,
} from "bootstrap-vue";

export default {
	components: {
		BContainer,
		BRow,
		BCol,
		BLink,

		sbSignup,
		// sbSignup: () => import('../components/Signup.vue'),
	},
	data: function() {return{}},
}
</script>

<style lang="scss">
.form-group {
	margin-bottom: .5rem;
	.col-form-label {
		padding-bottom: calc(0.125rem + 1px);
	}
}
</style>
